import { useCallback } from "react";
import { EntryExtensionData } from '@alme/types/response/EntryExtensionData';
import defaultLogger from '../Logger';
import { AlmeAppState, AlmeSavedAppState } from "../components/AlmeApp/AlmeAppState";
import { CookieLoader } from "@alme/storage-ts/CookieLoader";

export function useSetAlmeStateCallback(
    setAlmeState: (state: AlmeAppState) => void,
    savedAppState: CookieLoader<AlmeSavedAppState>,
): (state: AlmeAppState) => void {
    return useCallback((state: AlmeAppState): void => {
        state.lastEntryId = (state.history.length &&
            (state.history[state.history.length - 1].extensionData as EntryExtensionData).entryId) || undefined;

        try {
            savedAppState.UpdateStorage({
                isOpen: state.isOpen,
                lastEntryId: state.lastEntryId,
                isMinimized: state.isMinimized,
            });
        } catch (ex) {
            defaultLogger.error(ex);
        }
        return setAlmeState(state);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}